export const ADD_PRODUCTS_DATA = 'ADD_PRODUCTS_DATA';
export const ADD_CART = 'ADD_CART';
export const DELETE_CART = 'DELETE_CART';
export const ADD_CHECKOUT = 'ADD_CHECKOUT';
export const DELETE_CHECKOUT = 'DELETE_CHECKOUT';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';